import { ContractInfoDto } from "../../../../../Entities/Dto/ContractInfoDto";
import { translate } from "../../../../../Locales/i18n/localizationService";
import * as DateEx from "../../../../../Utilities/DateEx";
import { StringEx } from "../../../../../Utilities/StringEx";
import { IWizardContext } from "../../../../Common/Wizard/StepWizard";

const validateForNull = (value: any, errorMessage: string, errorHandler: (msg: string) => void) : boolean => {
	if (value != null && value !== "" && value !== 0) return true;
	errorHandler(errorMessage);
	return false;
}

export const validateStep1 = (errorHandler: (msg: string) => void) => (dto: ContractInfoDto, ctx: IWizardContext) : boolean => {
	const resourceValidation = validateForNull(dto.ResourceId, translate.t("FindAvailableCapacityDialog.ResourceMustBeSpecified"), errorHandler);
	// TODO: only for LMs
	const nameValidation = validateForNull(dto.ContractName, translate.t("FindAvailableCapacityDialog.ContractNameMustBeSpecified"), errorHandler);
	return resourceValidation && nameValidation;
}

export const validateStep2 = (errorHandler: (msg: string) => void) => (dto: ContractInfoDto, ctx: IWizardContext) : boolean => {
	const startValidation = validateForNull(dto.Start, translate.t("FindAvailableCapacityDialog.StartMustBeSpecified"), errorHandler);
	const endValidation = ctx.getPropertyValue("action") === "distribute" ? validateForNull(dto.End, translate.t("FindAvailableCapacityDialog.EndMustBeSpecified"), errorHandler) : true;
	const workValidation = validateForNull(dto.Work, translate.t("FindAvailableCapacityDialog.WorkMustBeSpecified"), errorHandler);

	const startEndValidation = DateEx.isNullOrMin(dto.End) || new Date(dto.End) > new Date(dto.Start);
	if (!startEndValidation) {
		errorHandler(translate.t("Common.EndGreaterThanStart"))
	}
	const freezePeriodValidation = ContractInfoDto.ValidateStart(dto, "Start");
	if (!freezePeriodValidation) {
		errorHandler(translate.t("ContractInfoDto.StartGreaterThanFreezePeriod"))
	}
	const earliestValidation = dto.EarliestStart == null || ContractInfoDto.ValidateStart(dto, "EarliestStart");
	if (!earliestValidation) {
		errorHandler(translate.t("ContractInfoDto.EarliestStartGreaterThanFreezePeriod"))
	}
	const latestValidation = dto.LatestEnd == null || new Date(dto.LatestEnd) > new Date(dto.EarliestStart);
	if (!latestValidation) {
		errorHandler(translate.t("ContractInfoDto.LatestEndGreaterThanEarliestStart"))
	}
	return startValidation && endValidation && workValidation && startEndValidation && freezePeriodValidation && earliestValidation && latestValidation;
}

export const validateStep3 = (errorHandler: (msg: string) => void) => (dto: ContractInfoDto, ctx: IWizardContext) : boolean => {
	if (dto.UseScenario) {
		
		const scenarioValidation = dto.Scenario != null || !StringEx.isNullOrWhiteSpace(dto.ScenarioName);
		if (!scenarioValidation) {
			errorHandler(translate.t("FindAvailableCapacityDialog.ScenarioNotFilledOut"))
		}
		return scenarioValidation;
	}
	return true;
}